// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"27d84ff3","247":"2ab5844f","290":"917271dd","869":"e7cd027b","950":"b7d83eac"}[chunkId] + ".chunk.js";
};